import { render, staticRenderFns } from "./TsPagination.vue?vue&type=template&id=d424c0c4&scoped=true&"
import script from "./TsPagination.vue?vue&type=script&lang=ts&"
export * from "./TsPagination.vue?vue&type=script&lang=ts&"
import style0 from "./TsPagination.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TsPagination.vue?vue&type=style&index=1&id=d424c0c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d424c0c4",
  null
  
)

export default component.exports